import { render, staticRenderFns } from "./CodeBlock.vue?vue&type=template&id=2c8ecdbf&scoped=true&"
import script from "./CodeBlock.vue?vue&type=script&lang=js&"
export * from "./CodeBlock.vue?vue&type=script&lang=js&"
import style0 from "./CodeBlock.vue?vue&type=style&index=0&id=2c8ecdbf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8ecdbf",
  null
  
)

export default component.exports